import {
  removeGlobalErrorMessageIfMatchesThisString,
  updateGlobalErrorMessage
} from "../../../actions/globalError";
import { removeGlobalSuccessMessageIfMatchesThisString } from "../../../actions/globalSuccess";
import {
  updateInvoice,
  updateBookingToInvoice,
  createInvoice,
  updateInvoiceAfterPayment
} from "../../../actions/checkoutAppointmentStep";
import { clone } from "../../../reducers/helper";
import { decimalPoint } from "../../../utils/helpers";

export function createPayloadItemFromInvoiceItem(invoiceItem) {
  let payloadItem = {};
  payloadItem.amount = invoiceItem.amount;
  if (invoiceItem.type) {
    payloadItem.type = invoiceItem.type;
  }
  if (invoiceItem.description) {
    payloadItem.description = invoiceItem.description;
  }
  if (invoiceItem.amounttype) {
    payloadItem.amounttype = invoiceItem.amounttype;
  }
  if (invoiceItem.reference) {
    payloadItem.reference = invoiceItem.reference;
  }
  if (invoiceItem.tax) {
    payloadItem.taxkey = invoiceItem.tax.key;
  }
  if (invoiceItem.count) {
    payloadItem.count = invoiceItem.count;
  }
  return payloadItem;
}

export function createInvoicePayload(
  multiServiceItem,
  appointmentStepData,
  bookingRevenue,
  posSettings,
  currentBookingId,
  invoiceData
) {
  let { selectedService } = multiServiceItem;
  let { selectedCustomer } = appointmentStepData;

  const itemTax = {
    type: "BOOKING",
    description: selectedService.name
      ? selectedService.name
      : "Service not specified",
    count: 1,
    amount: bookingRevenue ? bookingRevenue : 0,
    reference: currentBookingId
  };
  const itemDiscount = (invoiceData.items || []).find(
    x => x.type == "DISCOUNT"
  );

  if (
    posSettings &&
    posSettings.taxsettings &&
    posSettings.taxsettings.globalservicetax &&
    posSettings.taxsettings.globalservicetax.key &&
    posSettings.taxsettings.globalservicetax.active
  ) {
    itemTax.taxkey = posSettings.taxsettings.globalservicetax.key;
  }

  const payload = {
    customerid: selectedCustomer.id,
    items: [itemTax]
  };
  if (itemDiscount) {
    payload.items.push(itemDiscount);
  }
  return payload;
}

export function confirmServicePriceChangeAndGenerateInvoice(
  price,
  name,
  multiItemIndex,
  multiServiceItem,
  currentBookingId,
  invoiceData,
  appointmentStepData,
  updateAppointmentStep,
  bookingRevenue,
  posSettings,
  dispatch,
  cb
) {
  let { InvoiceCantBeOverpaid } = window.APP.LANGUAGE.Errors;
  const { paymentsEnabled } = appointmentStepData;
  const checkoutServicePrice = decimalPoint(Number(price));
  if (multiItemIndex != undefined) {
    let copy = clone(multiServiceItem.selectedService);
    copy.price = checkoutServicePrice;
    updateAppointmentStep({ selectedService: copy }, multiItemIndex);
    dispatch(
      removeGlobalErrorMessageIfMatchesThisString(InvoiceCantBeOverpaid)
    );
  }
  let payload;
  if (invoiceData && invoiceData.status != "PAID") {
    if (
      Number(price) < invoiceData.balanceamount &&
      appointmentStepData.paymentStatus == "invoicePartialPaid"
    ) {
      //DES-771 allow price and service change when partially paid.(if new price is greater than previous paid)
      dispatch(
        removeGlobalSuccessMessageIfMatchesThisString(
          window.APP.LANGUAGE.Success.SavedBookingSuccess
        )
      );
      dispatch(
        updateGlobalErrorMessage({
          message: window.APP.LANGUAGE.Errors.NotAllowedToUpdateService
        })
      );
      dispatch(
        updateInvoiceAfterPayment({ isNewPriceLessThanInvoicePaid: true })
      );
    } else {
      dispatch(
        updateInvoiceAfterPayment({ isNewPriceLessThanInvoicePaid: false })
      );
      dispatch(
        removeGlobalErrorMessageIfMatchesThisString(
          window.APP.LANGUAGE.Errors.NotAllowedToUpdateService
        )
      );
      if (paymentsEnabled && invoiceData && invoiceData.duedate) {
        const formattedDueDate =
          invoiceData.duedate.length > 9
            ? invoiceData.duedate
            : invoiceData.duedate.replace("Z", "T000000Z");
        payload = {
          customerid: invoiceData.customerid,
          duedate: formattedDueDate,
          items: []
        };
        invoiceData.items.map(invoiceItem => {
          let payloadItem = createPayloadItemFromInvoiceItem(invoiceItem);
          if (invoiceItem.reference == currentBookingId) {
            payloadItem.amount = checkoutServicePrice;
            if (name) {
              payloadItem.description = name;
            }
          }
          payload.items.push(payloadItem);
        });
        dispatch(updateInvoice(invoiceData.key, payload));
        dispatch(
          updateBookingToInvoice(
            currentBookingId,
            { revenue: checkoutServicePrice },
            cb
          )
        );
      } else {
        payload = createInvoicePayload(
          multiServiceItem,
          appointmentStepData,
          bookingRevenue,
          posSettings,
          currentBookingId,
          invoiceData
        );
        dispatch(createInvoice(payload, cb));
      }
    }
  }
}
